export default "__VITE_ASSET__Ct77wPP$__"